import { ChartData } from '../data/ChartData';
import { ChartDataArray } from '../data/ChartDataArray';
import { ColumnBarChartAttrHandler } from './ColumnBarChartAttrHandler';
import { StackedColumnBarRenderer } from './StackedColumnBarRenderer';

export class StackedColumnRenderer extends StackedColumnBarRenderer {
  constructor(gElement: d3.Selection<SVGGElement, unknown, null, undefined>, filled: boolean) {
    super(gElement, filled);
  }

  public render(
    arrays: Array<ChartDataArray>,
    x: d3.ScaleBand<string>,
    y: d3.ScaleLinear<number, number>,
    limit?: number
  ) {
    const barWidth = Math.min(StackedColumnRenderer.MAX_BAR_WIDTH, x.bandwidth() - StackedColumnRenderer.PADDING);
    const padding = x.bandwidth() - barWidth;

    const handlers: ColumnBarChartAttrHandler = {
      x: (d: ChartData | any) => x(<string>(<unknown>d.data.label))! + padding / 2,
      y: (d: Array<number>) => Math.max(y(!isNaN(d[1]) ? d[1] : 0), 0),
      height: (d: Array<number>) => y(d[0]) - y(!isNaN(d[1]) ? d[1] : 0),
      width: () => barWidth,
    };

    super.renderInternal(arrays, handlers, limit);
  }

  public switchHighlight(_index: number, _highlight: boolean) {}
}
